import axios from "axios";
const getCoinPrice = async (coin) => {
    let q = await axios.get('https://api.binance.com/api/v3/ticker/price?symbol=' + coin + 'USDT');
    return Number(q.data.price);
}
export default getCoinPrice;